import firebase from "firebase";
import { db_user } from "../firestore_user";

/**
 * @param {object} project - Firestore project document data
 * @param {string} contractKey - e.g. PROJECT_CONTRACT_KEYS.YOUTUBE_LICENSE
 * @param {string} userId - Firebase uid
 * @returns {{ signerName: string, signedAt: * } | null}
 */
export function getProjectContractSignature(project, contractKey, userId) {
  if (!project || !contractKey || !userId) return null;
  const entry = project.contractSignatures?.[contractKey]?.[userId];
  if (
    !entry ||
    typeof entry.signerName !== "string" ||
    !entry.signerName.trim()
  ) {
    return null;
  }
  return entry;
}

export function isProjectContractSigned(project, contractKey, userId) {
  return Boolean(getProjectContractSignature(project, contractKey, userId));
}

/**
 * Persist typed-name signature for the current user on the project document.
 * @param {string} projectId
 * @param {string} contractKey
 * @param {string} userId
 * @param {string} signerName
 */
export async function saveProjectContractSignature(
  projectId,
  contractKey,
  userId,
  signerName
) {
  const name = (signerName || "").trim();
  if (!projectId || !contractKey || !userId || !name) {
    throw new Error("Missing project, contract, user, or signer name");
  }
  const fieldPath = `contractSignatures.${contractKey}.${userId}`;
  await db_user
    .collection("projects")
    .doc(projectId)
    .update({
      [fieldPath]: {
        signerName: name,
        signedAt: firebase.firestore.FieldValue.serverTimestamp(),
      },
    });
}
